export interface AitiCoreCustomerData {
    id: number;
    loggedIn: boolean;
    name: string;
    email: string;
}

export default class AitiCoreCustomer {

    private _data: AitiCoreCustomerData;

    init(data: AitiCoreCustomerData) {
        this._data = data;
    }

    getId(): number {
        return this._data.id;
    }

    isLoggedIn(): boolean {
        return this._data.loggedIn;
    }

    getName(): string {
        return this._data.name;
    }

    getEmail(): string {
        return this._data.email;
    }
}
